export default __webpack_public_path__ + "static/media/carga.f79d04e4.gif";